import { ApolloLink as a, Observable as v, HttpLink as _, ApolloClient as D, InMemoryCache as F, ApolloProvider as G } from "@apollo/client";
import { onError as S } from "@apollo/client/link/error";
import { asyncMap as y } from "@apollo/client/utilities";
import $ from "../../../common-lib/hooks/metadata/useInjectMetadata.js";
import { ApiContextOptions as J } from "../../constants/apollo.js";
import { ERROR_CODE as Q } from "../../constants/error.js";
import { SHARE_OPERATIONS_WITH_AUTH as C } from "../../constants/graphql.js";
import { AssetType as E } from "../../constants/url.js";
import { useConfigContext as U } from "../config/ConfigContext.js";
import { useLogicControlContext as W } from "../share/LogicControlContext.js";
import { fetchWithAuth as z } from "../../graphql/helper/authFetch.js";
import B from "../../hooks/errors/useErrorHandler.js";
import K from "../../hooks/generic/useApeironPathMaker.js";
import * as r from "ramda";
import { useRef as V, useCallback as d, useMemo as s, useEffect as X } from "react";
import { jsx as Y } from "react/jsx-runtime";
const ft = (w) => {
  const {
    children: M
  } = w, {
    config: j
  } = U(), {
    apollo: o
  } = j, {
    makePath: p
  } = K(), {
    setForceLogout: f,
    setGeneralError: h
  } = W(), {
    getErrorMessage: g
  } = B(), {
    fetchMetadata: N,
    injectMetadata: O,
    injectMetadataLegacyMode: k
  } = $(), c = V({
    authOperations: r.concat(C, (o == null ? void 0 : o.authOperations) || []),
    buildId: (o == null ? void 0 : o.buildId) || "",
    domains: {
      api: (o == null ? void 0 : o.domain) || "",
      json: p(E.Json, ""),
      login: (o == null ? void 0 : o.domainLogin) || ""
    }
  }), P = d((t) => r.includes(t.operationName, c.current.authOperations), []), L = d((t) => {
    var u;
    const {
      operation: e
    } = t, n = "operation" in e.query.definitions[0] && ((u = e.query.definitions[0]) == null ? void 0 : u.operation) || "", i = e.operationName || "", l = e.getContext()[J.SkipError] || !1;
    if (n === "mutation" && !l) {
      const m = g(t);
      h(m), console.error(`Api | ${i} | ${m}`);
    }
  }, [g, h]), A = d((t) => {
    const {
      networkError: e
    } = t;
    e && (e.code || r.pathOr(0, ["result", "errors", 0, "extensions", "subCode"], e)) === Q.GRAPHQL.FORCE_LOGOUT && f(!0);
  }, [f]), b = d((t) => {
    L(t), A(t);
  }, [L, A]), x = s(() => new a((t, e) => r.isNotNil(o) ? e(t) : new v((n) => {
    n.next({
      data: null
    }), n.complete();
  })), [o]), I = s(() => new a((t) => {
    const {
      domain: e
    } = t.getContext(), {
      api: n,
      login: i
    } = c.current.domains;
    return new _({
      uri: e || n,
      credentials: "same-origin",
      fetch: async (u, m) => {
        const [T] = await Promise.all([z(u, m, {
          loginDomain: i,
          authRequired: P(t),
          graphql: !0
        }), N()]);
        return T;
      }
    }).request(t);
  }), []), R = s(() => new a((t, e) => y(e(t), async (n) => r.isNotNil(n.data) ? r.assoc("data", k(n.data), n) : n)), [k]), q = s(() => new a((t, e) => y(e(t), async (n) => {
    const {
      buildId: i
    } = c.current;
    return await O(n, i);
  })), [O]), H = s(() => {
    const t = S(b);
    return new D({
      cache: new F(),
      defaultOptions: {
        watchQuery: {
          fetchPolicy: "no-cache"
        },
        query: {
          fetchPolicy: "no-cache"
        },
        mutate: {}
      },
      link: a.from([x, t, R, q, I])
    });
  }, []);
  return X(() => {
    r.isNotNil(o) && (c.current = {
      authOperations: r.concat(C, o.authOperations),
      buildId: o.buildId,
      domains: {
        api: o.domain,
        json: p(E.Json, ""),
        login: o.domainLogin
      }
    });
  }, [o, p]), /* @__PURE__ */ Y(G, {
    client: H,
    children: M
  });
};
export {
  ft as ApolloProvider
};
//# sourceMappingURL=ApolloProvider.js.map
